module.exports = __webpack_public_path__ + "img/img2.8b579e04.png";